import { render } from "./NotificationCard.vue?vue&type=template&id=c29465b8&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import "./NotificationCard.vue?vue&type=style&index=0&id=c29465b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29465b8"]])

export default __exports__